import { render, staticRenderFns } from "./SetupSubstep.vue?vue&type=template&id=7f8aa552&"
import script from "./SetupSubstep.vue?vue&type=script&lang=js&"
export * from "./SetupSubstep.vue?vue&type=script&lang=js&"
import style0 from "./SetupSubstep.vue?vue&type=style&index=0&id=7f8aa552&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports